import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

function formatLogTime(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function actorAlreadyInText(text, actorName) {
  const name = String(actorName || "").trim();
  const body = String(text || "").trim();
  if (!name || !body) return false;
  return body.toLowerCase().startsWith(name.toLowerCase());
}

const TaskActivityLogLine = ({
  text,
  actorName = "",
  createdAt = null,
  compact = false,
}) => {
  const theme = useTheme();
  const time = formatLogTime(createdAt);
  const who = String(actorName || "").trim();
  const what = String(text || "").trim();
  const line = [
    who && !actorAlreadyInText(what, who) ? who : null,
    what || null,
    time || null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        py: compact ? 0.15 : 0.35,
        px: 1,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "flex-start",
          gap: 0.6,
          maxWidth: "min(520px, 96%)",
          color: theme.palette.text.secondary,
        }}
      >
        <Box
          sx={{
            width: 5,
            height: 5,
            borderRadius: "50%",
            bgcolor: theme.palette.text.disabled,
            flexShrink: 0,
            mt: "0.45em",
          }}
        />
        <Typography
          variant="caption"
          component="div"
          sx={{
            fontSize: "0.72rem",
            lineHeight: 1.45,
            textAlign: "center",
            color: "inherit",
            fontStyle: "italic",
          }}
        >
          {line}
        </Typography>
      </Box>
    </Box>
  );
};

export function isTeamActivityLogMessage(msg) {
  if (!msg) return false;
  const meta = msg.metadata && typeof msg.metadata === "object" ? msg.metadata : {};
  if (meta.source === "task_activity") return true;
  const authorType = String(msg.authorType || "").toLowerCase();
  const messageType = String(msg.messageType || "").toLowerCase();
  return authorType === "system" || messageType === "system";
}

export default TaskActivityLogLine;
